import type { errors as en } from '@/i18n/locales/en/errors';
import type { Translation } from '@/i18n/types';

export const errors: Translation<typeof en> = {
  loading: 'Lade {{label}}…',
  forbidden: 'Kein Zugriff auf {{label}}.',
  notFound: '{{label}} wurde nicht gefunden.',
  loadingFailed: 'Laden von {{label}} fehlgeschlagen: {{message}}',
  submitForbidden: 'Das darfst du nicht tun{{suffix}}',
  submitConflict: 'Das steht im Widerspruch zum aktuellen Zustand{{suffix}}',
  submitGeneric: 'Etwas ist schiefgelaufen: {{message}}',
};
